import React from 'react';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 lg:p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Terms of Service</h1>
          <p className="text-sm text-gray-600 mb-8">Last Updated: November 2024</p>

          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              By accessing and using the El Bethel Church website ("Service"), you accept and agree to be 
              bound by the terms and provision of this agreement. If you do not agree to these terms, 
              please do not use our Service.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Use of Service</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Our Service is intended for:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
              <li>Providing information about El Bethel Church</li>
              <li>Sharing biblical teachings and devotional content</li>
              <li>Facilitating communication with church members and visitors</li>
              <li>Processing prayer requests and contact inquiries</li>
              <li>Accepting donations for church ministry</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. User Conduct</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              You agree to use our Service in a manner consistent with Christian values and principles. 
              You will not:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
              <li>Use the Service for any illegal purpose</li>
              <li>Harass, abuse, or harm others</li>
              <li>Submit false or misleading information</li>
              <li>Attempt to gain unauthorized access to the Service</li>
              <li>Interfere with the proper functioning of the Service</li>
              <li>Use the Service to distribute spam or malicious content</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Intellectual Property</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              All content on this website, including text, graphics, logos, images, sermons, and devotional 
              materials, is the property of El Bethel Church or its content suppliers and is protected by 
              copyright and intellectual property laws.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              You may view and print content for personal, non-commercial use. Any other use requires 
              written permission from El Bethel Church.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Donations</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              All donations made through our Service are voluntary and non-refundable. Donations are 
              processed through secure third-party payment processors. By making a donation, you agree to 
              their terms of service as well.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Prayer Requests and Submissions</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              By submitting prayer requests or other content to our Service, you grant El Bethel Church 
              the right to use, share, and pray for these requests within our church community. Personal 
              information will be kept confidential as outlined in our Privacy Policy.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Disclaimer of Warranties</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The Service is provided "as is" and "as available" without warranties of any kind, either 
              express or implied. We do not warrant that the Service will be uninterrupted, secure, or error-free.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              El Bethel Church shall not be liable for any indirect, incidental, special, consequential, 
              or punitive damages resulting from your use of or inability to use the Service.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">9. External Links</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Our Service may contain links to external websites. We are not responsible for the content 
              or practices of these external sites. Linking to external sites does not imply endorsement.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">10. Modifications</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We reserve the right to modify or discontinue the Service at any time without notice. We may 
              also modify these Terms of Service at any time. Continued use of the Service after changes 
              constitutes acceptance of the modified terms.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">11. Governing Law</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              These Terms shall be governed by and construed in accordance with the laws of the State of Texas, 
              United States, without regard to its conflict of law provisions.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">12. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you have any questions about these Terms of Service, please contact us:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700">Email: contact@elbethel.church</p>
              <p className="text-gray-700">Address: 765 W Westchester Pkwy #541221, Grand Prairie, TX 75052</p>
              <p className="text-gray-700">Church Location: Grand Prairie, TX (contact us for address details)</p>
            </div>

            <div className="mt-8 p-4 bg-blue-50 border-l-4 border-blue-500 rounded">
              <p className="text-gray-700">
                <strong>Note:</strong> By using our Service, you acknowledge that you have read, understood, 
                and agree to be bound by these Terms of Service and our Privacy Policy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;